import { cookiePreferences } from "./cookie-consents";

export function init () {    
    const primaryVideos = document.querySelectorAll('.js-primary-video');
    
    // Loop over all play triggers to setup associated video embeds etc
    primaryVideos.forEach((container, i) => {
        let video = container.querySelector('iframe'),
            options = {
                events: {
                    'onReady': (event) => {
                        // If we have the autoplay dataset we can try to autoplay immediately
                        if (container.dataset.autoplay) {
                            event.target.playVideo();        
                        }
                    }
                }
            },
            player;

        // If either analytics or advertising consent NOT given, swap out video for one loaded over no-cookie domain
        if (!cookiePreferences.analytics || !cookiePreferences.analytics) {
            // Rebuild player using no-cookie src domain
            // Get the video ID from the existing src
            const srcComponents = video.src.split('/');
            const videoId = srcComponents[srcComponents.length - 1];
            
            let newVideo = document.createElement('div');

            newVideo.id = 'primary-video-' . i;

            // Replace original video with new video placeholder div
            video.replaceWith(newVideo);
            
            options.videoId = videoId;
            options.width = '1280';
            options.height = '720';
            options.host = 'https://www.youtube-nocookie.com';

            // Build YouTube player
            player = new YT.Player(newVideo, options); 
        } else {
            //  Add unique ID to the video element and ensure the src has the enable api query string parameter
            video.id = 'primary-video-' . i;

            if (video.src.indexOf('?') !== -1) {
                video.src = video.src + '&enablejsapi=1';
            } else {
                video.src = video.src + '?enablejsapi=1';
            }

            // Build YouTube player
            player = new YT.Player(video, options); 
        }
    });
}